<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title class="primary py-2">
        <span class="text-subtitle-1 font-weight-medium">Add Vendor Tariff</span>
        <v-spacer />
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="contractForm" v-model="isValid">
          <v-row>
            <v-col cols="12" md="6" class="Form-Columns-Dense">
              <Autocomplete
                :loading="transporterLoading"
                :totalItems="transporterCount"
                :items="allTransporterList"
                @updateList="getTransporterList"
                label="Select Transporter *"
                itemText="company_name"
                itemValue="id"
                :rules="[(v) => !!v || 'Transporter is Required']"
                hide-details="auto"
                v-model="form.transporter"
                :error-messages="formErrors.transporter"
                @input="delete formErrors.transporter"
              />
            </v-col>

            <v-col cols="12" md="6" class="Form-Columns-Dense">
              <MultiSelect
                label="Job Type *"
                :items="jobTypeOptions"
                itemText="display_name"
                itemValue="value"
                :rules="[(v) => !!v || 'Job Type is Required']"
                hide-details="auto"
                v-model="form.job_type"
                :error-messages="formErrors.job_type"
                @input="delete formErrors.job_type"
              />
            </v-col>

            <v-col cols="12" md="6" class="Form-Columns-Dense">
              <DateField
                :inputProps="{
                  dense: true,
                  label: 'Start Date *',
                  'hide-details': 'auto',
                  rules: [(v) => !!v || 'Start Date is Required'],
                  'error-messages': formErrors.start_date,
                }"
                :min="today"
                v-model="form.start_date"
                @input="delete formErrors.start_date"
              />
            </v-col>

            <v-col cols="12" md="6" class="Form-Columns-Dense">
              <DateField
                :inputProps="{
                  dense: true,
                  label: 'End Date *',
                  'hide-details': 'auto',
                  rules: [(v) => !!v || 'End Date is Required'],
                  'error-messages': formErrors.end_date,
                }"
                :min="form.start_date"
                v-model="form.end_date"
                @input="delete formErrors.end_date"
              />
            </v-col>

            <v-col cols="12" md="6" class="Form-Columns-Dense">
              <InputField
                type="text"
                label="Admin Remarks"
                hide-details="auto"
                v-model="form.admin_remarks"
                :error-messages="formErrors.admin_remarks"
                @input="delete formErrors.admin_remarks"
              />
            </v-col>

            <!-- <v-col cols="12" md="6" class="Form-Columns-Dense">
              <InputField
                type="text"
                label="Transporter Remarks"
                hide-details="auto"
                v-model="form.transporter_remarks"
                :error-messages="formErrors.transporter_remarks"
                @input="delete formErrors.transporter_remarks"
              />
            </v-col> -->
          </v-row>

          <p v-if="formErrors.non_field_errors" class="error--text mt-2 text-caption">
            {{ Array.isArray(formErrors.non_field_errors) ? formErrors.non_field_errors.join(', ') : formErrors.non_field_errors }}
          </p>
        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="primary" depressed :disabled="!isValid" @click="submitForm">Submit</v-btn>
        <v-btn depressed @click="resetForm">Reset</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Autocomplete from "@/components/FormBaseComponents/Autocomplete.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import DateField from "@/components/FormBaseComponents/DateField.vue";
import InputField from "@/components/FormBaseComponents/InputField.vue";

export default {
  components: { Autocomplete, MultiSelect, DateField, InputField },
  props: {
    value: { type: Boolean, default: false },
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.resetForm();
        this.getTransporterList();
      }
    },
  },
  data() {
    return {
      isValid: false,
      formErrors: {},
       today: new Date().toISOString().slice(0, 10),
      form: { transporter: null, job_type: null, start_date: null, end_date: null, admin_remarks: null, transporter_remarks: null },

      allTransporterList: [],
      transporterCount: 0,
      transporterLoading: false,

      jobTypeOptions: [
        { display_name: "Import", value: "Import" },
        { display_name: "Export", value: "Export" },
        { display_name: "FCL", value: "FCL" },
        { display_name: "LCL", value: "LCL" },
        { display_name: "Empty", value: "Empty" },
      ],
    };
  },
  methods: {
    resetForm() {
      this.form = { transporter: null, job_type: null, start_date: null, end_date: null, admin_remarks: null, transporter_remarks: null, transporter_contract_rates: [] };
      this.formErrors = {};
      this.$nextTick(() => { this.$refs.contractForm && this.$refs.contractForm.resetValidation(); });
    },
    closeDialog() {
      this.dialog = false;
    },
    submitForm() {
      this.$bus.$emit("showLoader", true);
      const payload = {
        ...this.form,
        transporter: this.form.transporter && typeof this.form.transporter === "object"
          ? this.form.transporter.id
          : this.form.transporter,
      };
      this.$api.transporterContract
        .addTransporterContract(payload)
        .then(() => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", { message: "Tariff added successfully!", color: "success" });
          this.$emit("refreshList");
          this.closeDialog();
        })
        .catch((err) => {
          this.formErrors = err.data || {};
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", { message: "Failed to add tariff!", color: "error" });
        });
    },
    getTransporterList(params = {}) {
      this.transporterLoading = true;
      this.$api.company
        .getCompanyList({ company_type: "Transporter", limit: 20, ...params })
        .then((res) => {
          if (params.offset) {
            this.allTransporterList = [...this.allTransporterList, ...res.data];
          } else {
            this.allTransporterList = res.data;
          }
          this.transporterCount = res.count;
          this.transporterLoading = false;
        })
        .catch(() => { this.transporterLoading = false; });
    },
  },
};
</script>
